const $addressesForm = $('.js-address-form');
const $updateButton = $('.js-address-update');

$addressesForm.find('input').on('keydown', function (e) {
	$updateButton.removeClass('is-disabled');
});

$addressesForm.find('select').on('change', function () {
	$updateButton.removeClass('is-disabled');
	$(this).addClass('selected');
});

$updateButton.on('click', function (e) {
	e.preventDefault();

	$addressesForm.find('form').submit();
});
